import {
    URLAPI,
    PURCHASE_PATH,
    PURCHASE_CREATE_PATH,
    PURCHASE_UPDATE_PATH,
    PURCHASE_REPORT_PATH,
    PURCHASE_ITEM_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_purchase: {
        data: [],

        status: 0,
        message: {},
    },
    _create_purchase: {
        data: {},
        status: 0,
        message: {},
    },
    _update_purchase: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_PURCHASE = "GET_ALL_PURCHASE";
export const CREATE_PURCHASE = "CREATE_PURCHASE";
export const UPDATE_PURCHASE = "UPDATE_PURCHASE";
export const GET_REPORT = "GET_REPORT";

export const purchase_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_PURCHASE:
            return {
                ...state,
                _get_all_purchase: action.payload,
            };
        case CREATE_PURCHASE:
            return {
                ...state,
                _create_purchase: action.payload,
            };
        case UPDATE_PURCHASE:
            return {
                ...state,
                _update_purchase: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllPurchase = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${PURCHASE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_PURCHASE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_PURCHASE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_PURCHASE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemPurchase = async (token, id) => {
    return await axios.get(`${URLAPI}${PURCHASE_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create purchase
export const createPurchase = (token, data) => async (dispatch) => {
    try {
        // let form = new FormData();
        //
        // for (var key in data) {
        //     form.append(key, data[key]);
        // }
        const response = await axios.post(
            `${URLAPI}${PURCHASE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_PURCHASE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_PURCHASE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_PURCHASE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updatePurchase = (token, id, data) => async (dispatch) => {
    try {
        // let form = new FormData();
        //
        // for (var key in data) {
        //     form.append(key, data[key]);
        // }
        const response = await axios.patch(
            `${URLAPI}${PURCHASE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_PURCHASE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_PURCHASE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_PURCHASE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + PURCHASE_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_purchase = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
